export const urlApi = process.env.REACT_APP_SERVER;
export const temp = 'temp';